import '../styles/BreakScreen.css';

const PREPARING_TEXT = 'Preparing session...';

export default function PreparingScreen({ topOffset = 0, text = PREPARING_TEXT }) {
  const displayText = text || PREPARING_TEXT;
  return (
    <div className='break_screen_overlay' style={{ top: topOffset }}>
      <div className='break_screen_content'>
        <div className='break_screen_text' aria-label={displayText}>
          {displayText.split('').map((char, i) => (
            <span
              key={`letter-${i}`}
              className='break_screen_letter'
              style={{ animationDelay: `${(i * 0.07) % 1.8}s` }}
            >
              {char === ' ' ? '\u00A0' : char}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
